import JitsiMeetJS from '../lib-jitsi-meet';

export function initializeLib() {
  JitsiMeetJS.init();
  console.log('JitsiMeetJS initialized successfully.');
}
